import { Injectable } from '@angular/core';
import { EditorButtonsConfig } from '@app/pages/main/pages/quality/models';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  getDefaultButtonsConfig(): EditorButtonsConfig {
    return {
      showFontButtons: true,
      showAlignButtons: true,
      showFormatButton: false,
      showIndentButton: false,
      showOutdentButton: false,
      showBackColorButton: true,
      showForeColorButton: true,
      showListButtons: true,
      showFontSizeButtons: true,
      showLinkButtons: true,
      showFontSizeButton: true,
      showFontFamilyButton: true,
      showAdditionalButtons: false,
      showInsertTableButton: false,
      showInsertImageButton: true,
    };
  }
}
